export const COMMON_CONSTANTS: ICommonConstants = {
  DEFAULT_ERROR_MESSAGE: "Something went wrong. Please try again later.",
  DEFAULT_ERROR_MESSAGE_404: "We couldn't find what you're looking for.",
  SESSION_EXPIRED: "Your session is expired, please login again!",
  POSITIVE_VALUE: "Y",
  NEGATIVE_VALUE: "N",
  FALLBACK_VALUE: "-",
  BUTTON: {
    SUBMIT: "Submit",
    CONTINUE: "Continue",
    NEXT: "Next",
    SAVE: "Save",
    UPDATE: "Update",
    CANCEL: "Cancel",
    CLOSE: "Close",
    BACK: "Back",
    SUBMIT_OTP: "Submit OTP",
    RESEND_OTP: "Resend OTP",
    GET_OTP: "Get OTP",
    LOGOUT: "Logout",
    APPLY: "Apply",
    APPLY_COUPON: "Apply Coupon",
    REMOVE_COUPON: "Remove Coupon",
    REMOVE_CODE: "Remove Code",
    PLACE_ORDER: "Place Order",
    PROFILE: "Profile",
    SEND_MESSAGE: "Send Message",
    ORDER_HISTORY: "View Order History",
    PAYMENT_HISTORY: "View Payment History",
  },
  TEXT: {
    OPS: "Oops!",
    YES: "Yes",
    NO: "No",
    CHECK_OUT_OUR_WEBSITE: "Check out our website",
    GO_BACK: "Go back",
    HAVE_A_COUPON_REFERRAL_CODE: "Have A Coupon/Referral Code?",
    HAVE_A_COUPON_CODE: "Have A Coupon Code?",
    HAVE_A_REFERRAL_CODE: "Have A Referral Code?",
    SUMMARY: "Summary",
    AVAILABLE_POINTS_TEXT: "Available Points :",
    CAN_BE_REDEEMED: "Can be redeemed",
    ADD_TO_CART: "Add to Cart",
    ADD_TO_WISHLIST: "Add to Wishlist",
    ENTER_CODE: "Enter code",
    POINTS: "Points",
    INR: "INR",
    PRODUCT: "Order Reward Details",
    USE: "Use",
    COUPON_CODE_PLACE_HOLDER: "Enter coupon code",
    COUPON_REFERRAL_PLACE_HOLDER: "Enter referral code",
    WRITE_TO_US: "Write to us",
    CONTACT_US: "Contact Us",
    RESEND_OTP_TEXT: "Didn't receive OTP?",
    AVAILABLE_POINTS_PAYMENT: "from Available Points for Payment.",
    SHIPPING_DETAILS_REQUIRED:
      "Please complete and update shipping details before placing the order.",
    PLEASE_CHECKOUT: "Please checkout to continue",
    REMOVE_CODE_BEFORE_APPLYING:
      "Please remove the code before applying another code",
    THANK_YOU_TITLE: "Thank You!",
    THANK_YOU_MESSAGE: "Your order has been placed successfully.",
    ORDER_ID_TEXT: "Order ID:",
    CONFIRMATION_MESSAGE: "You have earned 500 points against this order.",
    NOTIFICATION_TITLE: "Notifications",
    FULL_POINTS_PAYMENT_TEXT: (
      amount: number,
      points: number,
      currency?: string
    ) =>
      `${COMMON_CONSTANTS.TEXT.USE} ${amount} from Available ${points} ${currency} for Payment`,

    PAY_REMAINING: "Pay remaining",
    PAYMENT_GATEWAY: "through payment gateway..",
    FULL_REMAINING_PAYMENT_TEXT: (amount: number) =>
      `${COMMON_CONSTANTS.TEXT.PAY_REMAINING} ${amount} ${COMMON_CONSTANTS.TEXT.INR} ${COMMON_CONSTANTS.TEXT.PAYMENT_GATEWAY}`,

    YOU_WILL_EARN: "You will earn",
    POINTS_ON_THIS_PAYMENT: "Points on this payment",
    FULL_EARN_POINTS_TEXT: (value: number) =>
      `${COMMON_CONSTANTS.TEXT.YOU_WILL_EARN} ${value} ${COMMON_CONSTANTS.TEXT.POINTS_ON_THIS_PAYMENT}`,

    SIMPLE_BRAKET: (
      value: string,
      currency: string = COMMON_CONSTANTS.TEXT.INR
    ) => `(${value} ${currency})`,
    COUPON_TOOLTIP_TXT: (minAmount: number) =>
      `Coupon is applicable for minimum order amount of ${minAmount}`,
  },
};

interface ICommonConstants {
  DEFAULT_ERROR_MESSAGE: string;
  DEFAULT_ERROR_MESSAGE_404: string;
  SESSION_EXPIRED: string;
  POSITIVE_VALUE: string;
  NEGATIVE_VALUE: string;
  FALLBACK_VALUE: string;
  BUTTON: {
    SUBMIT: string;
    CONTINUE: string;
    NEXT: string;
    SAVE: string;
    UPDATE: string;
    CANCEL: string;
    CLOSE: string;
    BACK: string;
    SUBMIT_OTP: string;
    RESEND_OTP: string;
    GET_OTP: string;
    LOGOUT: string;
    APPLY: string;
    APPLY_COUPON: string;
    REMOVE_COUPON: string;
    REMOVE_CODE: string;
    PLACE_ORDER: string;
    PROFILE: string;
    SEND_MESSAGE: string;
    ORDER_HISTORY: string;
    PAYMENT_HISTORY: string;
  };
  TEXT: {
    YES: string;
    NO: string;
    OPS: string;
    CHECK_OUT_OUR_WEBSITE: string;
    GO_BACK: string;
    HAVE_A_COUPON_REFERRAL_CODE: string;
    HAVE_A_COUPON_CODE: string;
    HAVE_A_REFERRAL_CODE: string;
    SUMMARY: string;
    AVAILABLE_POINTS_TEXT: string;
    CAN_BE_REDEEMED: string;
    ADD_TO_CART: string;
    ADD_TO_WISHLIST: string;
    ENTER_CODE: string;
    POINTS: string;
    INR: string;
    PRODUCT: string;
    USE: string;
    COUPON_CODE_PLACE_HOLDER: string;
    COUPON_REFERRAL_PLACE_HOLDER: string;
    AVAILABLE_POINTS_PAYMENT: string;
    WRITE_TO_US: string;
    CONTACT_US: string;
    RESEND_OTP_TEXT: string;
    SHIPPING_DETAILS_REQUIRED: string;
    PLEASE_CHECKOUT: string;
    REMOVE_CODE_BEFORE_APPLYING: string;
    THANK_YOU_TITLE: string;
    THANK_YOU_MESSAGE: string;
    ORDER_ID_TEXT: string;
    CONFIRMATION_MESSAGE: string;
    NOTIFICATION_TITLE: string;
    FULL_POINTS_PAYMENT_TEXT: (
      amount: number,
      points: number,
      currency?: string
    ) => string;
    PAY_REMAINING: string;
    PAYMENT_GATEWAY: string;
    FULL_REMAINING_PAYMENT_TEXT: (amount: number) => string;
    YOU_WILL_EARN: string;
    POINTS_ON_THIS_PAYMENT: string;
    FULL_EARN_POINTS_TEXT: (value: number) => string;
    SIMPLE_BRAKET: (value: string, currency?: string) => string;
    COUPON_TOOLTIP_TXT: (minAmount: number) => string;
  };
}
